import { cn } from "@/utils/tailwind";
import { forwardRef } from "react";

export const AsideRoot = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      className={cn(
        "flex w-full gap-8 flex-col-reverse xl:flex-row",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});

interface AsideContentProps extends React.HTMLAttributes<HTMLElement> {
  sticky?: boolean;
}

export const AsideContent = forwardRef<HTMLElement, AsideContentProps>(
  ({ className, sticky = true, ...props }, ref) => {
    return (
      <aside
        className={cn(
          "flex flex-col gap-8 xl:w-[23%]",
          sticky && "top-20 sticky h-max",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);

export const AsideSection = forwardRef<
  HTMLElement,
  React.HTMLAttributes<HTMLElement>
>(({ className, ...props }, ref) => {
  return (
    <section
      className={cn("flex flex-col gap-8 xl:w-[77%]", className)}
      ref={ref}
      {...props}
    />
  );
});
